<template>
    <div v-if="content.contentTypeId === 4" class="content-document panel rounded col-12">
        <div style="display: flex; flex-direction: column;" class="col-xl-11 col-10">
            <p class="news-tag">{{ content.dateTime | moment($t("dateFormat")) }}</p>
            <span class="document-title"><a v-bind:href="content.url" target="_blank">{{ content.title }}</a></span>
        </div>
        <a v-bind:href="content.url" target="_blank" class="card-news-button col-xl-1 col-2">{{
            $t("download") }}</a>
    </div>
    <div v-else-if="content.contentTypeId === 3" class="news-article panel rounded">
        <div class="news-article-item">
            <div class="news-text">
                <div class="news-text-content col-12">
                    <p class="news-tag">{{ item.dateTime | moment($t("dateFormat")) }}</p>
                    <h3 class="news-text-content-h3"><router-link :to="{ name: 'news-content', params: { id: content.id } }">{{ truncatedTitle }}</router-link></h3>
                    <p v-html="truncatedHtmlContent" class="news-content-p"></p>
                </div>
            </div>
                <router-link :to="{ name: 'news-content', params: { id: content.id } }" class="card-news-button col-xl-1 col-2">
                {{ $t("more") }}
                </router-link>
        </div>
    </div>
    <div v-else class="panel rounded col-12"
        style="margin-bottom: 1%; padding: 10px; display: flex; background-color: var(--light-color);">
        <div class="col-xl-11 col-10">
            <router-link v-if="!isExternalLink" v-bind:to="computeRoute" tag="a">
                <span class="content-span-title">{{ content.title }}</span>
            </router-link>
            <a v-else v-bind:href="content.url" target="_blank">
                <div>
                    <span class="content-span-title">{{ content.title }}</span>
                </div>
            </a>
        </div>
        <div class="card-news-button col-xl-1 col-2">
            <router-link v-if="!isExternalLink" v-bind:to="computeRoute" tag="a">
                <div><span class="span-find-more"> {{ $t("more") }}</span></div>
            </router-link>
            <a v-else v-bind:href="content.url" target="_blank">
                <div>
                    <span class="font-size span-find-more"> {{ $t("more") }}</span>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import ContentTags from "./ContentTags.vue"
import { mapGetters, mapActions } from "vuex"

export default {
    data() {
        return {
            htmlContent: "",
            item: null,
        }
    },
    components: {
        appContentTags: ContentTags
    },
    props: ["content"],
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.fetchContentById(this.content.id).then((content) => {
                // this.item. = content;
                this.item.title = content.title;
                this.htmlContent = content.content;
                this.$nextTick(() => {
                    window.scrollTo(0, 0);
                });
            });
        },
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getContentTypes"]),
        getContentTags() {
            return this.content.tags ? JSON.parse(this.content.tags) : [];
        },
        isTagsPanelVisible() {
            return this.content.tags;
        },
        isExternalLink() {
            return (this.content.url != null && ((this.content.contentTypeId == this.getContentTypes.linkContentTypeId && this.content.url.startsWith("http")) ||
                (this.content.contentTypeId == this.getContentTypes.highlightedServicesTypeId && this.content.url.startsWith("http"))));
        },
        isInternalLink() {
            return (this.content.url != null && ((this.content.contentTypeId == this.getContentTypes.linkContentTypeId && !this.content.url.startsWith("http")) ||
                (this.content.contentTypeId == this.getContentTypes.highlightedServicesTypeId && !this.content.url.startsWith("http"))));
        },
        computeRoute() {
            return this.isInternalLink ? { name: this.content.url } : { name: 'contentNew', params: { id: this.content.id, slug: this.content.slug } };
        },
        truncatedHtmlContent() {
            const plainText = (this.htmlContent || '').replace(/<[^>]*>/g, '');
            return plainText.length > 150 ? plainText.substring(0, 150) + '...' : plainText;
        },
        truncatedTitle() {
            return this.item.title.length > 100 ? this.item.title.substring(0, 100) + '...' : this.item.title;
        }
    },
    created() {
        this.item = this.getContentById(this.content.id);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
        content() {
            this.loadData();
        }
    },
    updated() {
        var el = this.$el;
        el.scrollIntoView();
    }
}
</script>

<style scoped>
.content-document {
    margin-bottom: 10px !important;
    padding: 10px !important;
    background-color: var(--light-color) !important;
    display: flex !important;
    align-items: center !important;

}

.card-news-button {
    display: inline-block;
    padding: 10px 15px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    padding: 10px;
}

.card-news-button a,
.card-news-button router-link {
    text-decoration: none;
}

.span-find-more {
    color: var(--main-color);
    text-decoration: none;
    transition: color 0.3s ease, background-color 0.3s ease;
}

.card-news-button:hover .span-find-more {
    color: #FFF;
    text-decoration: underline;
    text-decoration-color: white;
}

.card-news-button:hover {
    background-color: white;
    transition: background-color 0.3s ease;
}


.text-muted {
    color: var(--main-color) !important;
    opacity: 0.6;
    font-weight: bold;
}

.btn {
    background-color: var(--main-color);
    color: white;
}

.btn:hover {
    background-color: #374e96;
    border-color: #374e96;
    color: white;
}

.panel {
    padding: 4%;
    background-color: #FFF;
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.10);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

/* NEWS content type id */

.news-article {
    border-radius: 15px;
    background-color: var(--light-color);
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
}

.news-article-item {
    display: flex;
    flex-direction: row;
    /* gap: 20px; */
    align-items: center;
}

.news-img {
    width: 200px;
    flex-shrink: 0;
}

.news-img img {
    width: 100%;
    height: 70px;
    object-fit: contain;
    border-radius: 10px;
}

.news-text {
    flex: 1;
    min-width: 0;
}

.news-text-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.news-text-content-h3 a{
    color: var(--main-color);
    font-size: 20px;
    font-weight: 600;
}

.news-text h3,
.document-title {
    color: var(--main-color);
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.document-title a{
    color: var(--main-color);
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}


.news-tag {
    color: #757575;
    font-size: 12px;
    line-height: 14px;
    margin: 0;
}

.news-content-p,
.document-title-text {
    color: #757575;
    font-size: 18px;
    line-height: 20px;
    margin: 0;
}

.button-wrapper {
    text-decoration: none;
    flex-shrink: 0;
    align-self: center;
}

.card-news-button {
    border: 1px var(--main-color) solid;
    background-color: transparent;
    border-radius: 5px;
    color: var(--main-color);
    font-size: 18px;
    text-align: center;
    padding: 8px 16px;
    white-space: nowrap;
    transition: all 0.3s ease;
}

.card-news-button:hover {
    background-color: var(--main-color);
    color: white;
}

/*NEWS content type id end*/

.content-span-title{
    font-weight: 600; 
    color: var(--main-color); 
    font-size: 18px;

}
.content-span-title a,
.content-span-title router-link {
    font-weight: 600; 
    color: var(--main-color) !important; 
    font-size: 18px;

}
@media (max-width: 768px) {
    .card-news-button {
        font-size: 14px;
        padding: 5px 12px;
        white-space: normal;
    }

    .span-find-more{
        text-align: center;
    }
}
</style>
